import { times } from 'lodash';
import { StarProps } from '../RatingStar/types';
import { RatingProps } from '../types';

export const formatStars = (variant: RatingProps['variant'], score: RatingProps['score']) => {
    const starCount = variant === 'full' ? 5 : 1;

    return times(starCount).map((index) => calculateStarStarVariant(score, index));
};

const calculateStarStarVariant = (score: RatingProps['score'], starIndex: number): StarProps['starVariant'] => {
    const normalizedScore = Math.round(score * 2) / 2;
    const filledStarCount = Math.floor(normalizedScore);
    const remainderStar = normalizedScore - filledStarCount;

    if (starIndex < filledStarCount) {
        return 'full';
    }
    if (starIndex === filledStarCount && remainderStar === 0.5) {
        return 'half';
    }

    return 'empty';
};
